module.exports = __webpack_public_path__ + "static/media/boggle.ab433e29.jpg";